import React from 'react';
import {observer} from 'mobx-react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {PayrollNotEnabled} from './components/not_enabled';

const PayrollNotEnabledSwitch = observer(() => {
  return (
    <Switch>
      <Route path='/learn_more' component={PayrollNotEnabled}/>
      <Redirect from='/' to='/learn_more'/>
    </Switch>
  );
});

export default PayrollNotEnabledSwitch;
